import { HashRouter } from 'react-router-dom';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';

import { AuthProvider } from './hooks/useAuth';
import { RecoilRoot } from 'recoil';
import { Theme } from './hooks/theme';
import { CssBaseline, Box } from '@mui/material';
import Router from './components/Router';
import ReactGA from 'react-ga4';
import { MixpanelProviderWrapper } from './components/MixpanelProviderWrapper';
import './App.css';

const TRACKING_ID = 'G-V403FFQ9RG';
if (process.env.NODE_ENV === 'production') {
  ReactGA.initialize(TRACKING_ID);
}
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <RecoilRoot>
          <AuthProvider>
            <Theme>
              <CssBaseline />
              <MixpanelProviderWrapper>
                <Box sx={{ display: 'flex' }}>
                  <Router />
                </Box>
              </MixpanelProviderWrapper>
            </Theme>
          </AuthProvider>
        </RecoilRoot>
      </HashRouter>
    </QueryClientProvider>
  );
}
